import { XMLBaseParser } from '../../../utils/XMLBaseParser';
import { WebviewAuthenticateResponse } from '../data/WebviewAuthenticateResponse';
import {
	authErrorString,
	WebviewAuthResponseParseError,
	UnsupportedCredentialTypeError,
} from '../../AuthErrors';
import { Logger } from '../../Logger';
import { logConstants } from '../../../utils/Constants';

export class WebviewAuthResponseParser extends XMLBaseParser<WebviewAuthenticateResponse> {
	readonly SUPPORTED_TYPE = 'webview';
	readonly SUCCESS = 'success';

	private static instance: WebviewAuthResponseParser;

	public static getInstance(): WebviewAuthResponseParser {
		if (!WebviewAuthResponseParser.instance) {
			WebviewAuthResponseParser.instance = new WebviewAuthResponseParser();
		}
		return WebviewAuthResponseParser.instance;
	}

	processParsedXML(json: any): WebviewAuthenticateResponse {
		const status = json.AuthenticateResponse.Status;
		if (status != this.SUCCESS) {
			Logger.getInstance().write(
				logConstants.ERROR,
				authErrorString.DSAUTH_WEBVIEW_AUTH_RESPONSE_FAILURE + ' ' + JSON.stringify(json)
			);
			throw new WebviewAuthResponseParseError(
				authErrorString.DSAUTH_WEBVIEW_AUTH_RESPONSE_FAILURE + ' status:' + status
			);
		}

		const requirement =
			json.AuthenticateResponse.AuthenticationRequirements.Requirements.Requirement;
		if (Array.isArray(requirement)) {
			for (const requirementObj of requirement) {
				const credential = requirementObj.Credential;
				if (this.validate(credential.Type)) {
					return new WebviewAuthenticateResponse(
						json.AuthenticateResponse.AuthenticationRequirements.PostBack,
						json.AuthenticateResponse.AuthenticationRequirements.CancelPostBack,
						credential.ID,
						credential.Type,
						credential.WebView.StartUrl.__text
					);
				}
			}
		} else {
			const credential = requirement.Credential;
			if (this.validate(credential.Type)) {
				return new WebviewAuthenticateResponse(
					json.AuthenticateResponse.AuthenticationRequirements.PostBack,
					json.AuthenticateResponse.AuthenticationRequirements.CancelPostBack,
					credential.ID,
					credential.Type,
					credential.WebView.StartUrl.__text
				);
			}
		}

		throw new UnsupportedCredentialTypeError(authErrorString.DSAUTH_NO_WEBVIEW);
	}

	private validate(type: string): boolean {
		if (type === this.SUPPORTED_TYPE) {
			return true;
		}
		return false;
	}
}
